import DevelopmentGrid from "components/grids/development";
import Sitting from "components/svgs/sitting";
import Group from "components/svgs/group";
import * as React from 'react';
export default {
  DevelopmentGrid,
  Sitting,
  Group,
  React
};